//#region Libraries
import { forwardRef } from 'react';
import {
    Slide
} from '@mui/material';
//#endregion
//#region Styles
import {
    Container,
} from './styles';
//#endregion

const Transition = forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogAlert = ({
    show, toggleShow,
    close, children, width, variant
}) => {
    return (
        <Container
            open={show}
            TransitionComponent={Transition}
            onClose={close ?? (() => toggleShow(false))}
            width={width}
            variant={variant}>
            {children}
        </Container>
    );
}


export default DialogAlert;
